module.exports = __webpack_public_path__ + "img/confusion.1ce3ec96.svg";